//import angular from 'angular';
const moduleName = "app.equipment";
export default moduleName;

angular.module(moduleName, []);
